import Vue from 'vue'
import Router from 'vue-router'
import login from '@/pages/login'
import Homepage from '@/pages/homepage'
import Record from '@/pages/encodeRecord'
import Help from '@/pages/help'

import {
  getStorage
} from '@/common/utils/localStorage'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  routes: [
    {
       path: '/',
       redirect: '/login'
    },
    {
      path: '/homepage',
      name: 'Homepage',
      component: Homepage
    },
    {
      path: '/login',
      name: 'Login',
      component: login
    },
    {
      path: '/record',
      name: 'Record',
      component: Record
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    }
  ]
})

router.beforeEach((to, from, next) => {
  const nextRoute = ['Homepage', 'Record', 'Help']
  let IS_LOGIN = false
  
  if (getStorage('ticket')) {
    IS_LOGIN =true
  }
  //console.log(IS_LOGIN);
  if (nextRoute.indexOf(to.name) >= 0) {
    if (!IS_LOGIN) {
      //console.log("进了Login1");
      router.push({name: 'Login'})
      //next();
    }
  }
  else if (from.name === 'Login' && IS_LOGIN) {
      router.push({name: 'Homepage'})
      //next();
  }
  //console.log(to.name);
  //console.log(from.name);
  next();
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js